export default __webpack_public_path__ + "static/media/google.a3035d61.svg";